<template>
  <cc-container>
    <cc-header-nav title="我的业绩" url="/#/management">
    </cc-header-nav>
    <cc-main id="container">
      <component :is="component"></component>
    </cc-main>
    <cc-footer>
      <ul class="footer">
        <li @click="changeTab(0)" :class="[selectIndex === 0 ? 'active' : '']">
          <cc-svg-icon icon-class="sales-summary" className="icon" size="17px"/>
          <span>销售汇总</span>
        </li>
        <li @click="changeTab(1)" :class="[selectIndex === 1 ? 'active' : '']">
          <cc-svg-icon icon-class="sales-details" className="icon" size="17px"/>
          <span>提成明细</span>
        </li>
      </ul>
    </cc-footer>
  </cc-container>
</template>
<script>
import Vue from 'vue'
import { Tab, Tabs, Actionsheet } from 'vant'
import { Calendar } from '@nutui/nutui'
// import { ResultCode } from '~const/ResultCode'
import ListMixin from '@/mixins/list'
// import { loadSaleCount } from '../../fetch/distributor'
import { myDate } from '@/utils'
import SalesSummary from './sales-summary'
import SalesDetails from './sales-details'
Vue.use(Tab)
  .use(Tabs)
  .use(Actionsheet)
Calendar.install(Vue)
export default {
  name: 'order-list',
  mixins: [ListMixin],
  components: {
    SalesDetails,
    SalesSummary
  },
  data () {
    return {
      component: 'sales-summary',
      selectIndex: 0,
      isShow: false,
      selectedText: '本周',
      isVisible: false,
      dateQuantum: null,
      form: {
        time_type: 1,
        start_time: '',
        end_time: ''
      }
    }
  },
  created () {
    this.dateQuantum = myDate.getWeekDate()
    this.loadData()
  },
  methods: {
    changeTab (type) {
      const components = ['sales-summary', 'sales-details']
      this.component = components[type]
      this.selectIndex = type
    },
    async loadData () {
      // let res = await loadSaleCount(this.form)
      // console.log(res)
    },
    onCancel () {
      this.isShow = false
    },
    onSelect (item) {
      this.isShow = false
      this.selectedText = item.name
      this.dateQuantum = myDate[item.fnc]()
    },
    setChooseValue (param) {
      this.dateQuantum = [...[param[0][3], param[1][3]]]
    }
  }
}
</script>
<style lang="scss" scoped>
.footer{
  height: 49px;
  width: 100%;
  background: #ffffff;
  display: flex;
  .active{
    color: var(--APP_theme_color);
  }
  li{
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>
